import { CircularProgress, Stack } from "@mui/material";


export const BigSpin = () => (
  <div style={{ margin: "auto" }}>
    <Stack>
      <CircularProgress size={100} />
      <h1>Loading...</h1>
    </Stack>
  </div>
);
